<template>
  <div class="MonthRangePicker">
    <a-month-picker
      v-model:value="monthStart"
      :size="size"
      :format="format"
      :disabledDate="StartDisableDate"
      :placeholder="placeholderStr[0]"
      suffix-icon=" "
    />
    <span class="spaceText">{{ spaceText }}</span>
    <a-month-picker
      v-model:value="monthEnd"
      :size="size"
      :format="format"
      :disabledDate="EndDisableDate"
      :placeholder="placeholderStr[1]"
      suffix-icon=" "
    />
  </div>
</template>

<script setup>
import moment from 'moment'
import { ref, defineProps, watch, defineEmits, defineExpose } from 'vue'

const props = defineProps({
  monthRange: {
    type: Array,
    default: () => []
  },
  size: {
    type: String,
    default: 'large'
  },
  format: {
    type: String,
    default: 'YYYY-MM'
  },
  defaultMonth: {
    type: Array,
    default: () => []
  },
  disabledDateType: {
    type: String,
    default: 'NULL'
  },
  spaceText: {
    type: String,
    default: '~'
  },
  placeholderStr: {
    type: Array,
    default: () => ['开始月份', '结束月份']
  }
})

const emits = defineEmits(['update:monthRange'])
const { disabledDateType, placeholderStr, spaceText, format, defaultMonth } = props || {}
const monthStart = defaultMonth ? ref(defaultMonth[0]) : ref()
const monthEnd = defaultMonth ? ref(defaultMonth[1]) : ref()
const safeFormat = time => {
  return time ? time.format(format) : ''
}
if (defaultMonth && defaultMonth[0] && defaultMonth[1]) {
  const [ds, de] = defaultMonth || []
  emits('update:monthRange', [safeFormat(ds), safeFormat(de)])
}
const disabledRules = ctx => {
  return {
    NULL: false,
    NOTALLOWAFTER: ctx > moment(),
    NOTALLOWBEFORE: ctx < moment()
  }
}

watch([monthStart, monthEnd], date => {
  const [start, end] = date || []
  emits('update:monthRange', [safeFormat(start), safeFormat(end)])
})

// rule1: 开始月份 < 结束月份 结束月份 > 开始月份
// rule2: 满足定制化禁用规则
const StartDisableDate = current => {
  if (!monthEnd.value) {
    return disabledRules(current)[disabledDateType]
  }
  return current > monthEnd.value || disabledRules(current)[disabledDateType]
}
const EndDisableDate = current => {
  if (!monthStart.value) {
    return disabledRules(current)[disabledDateType]
  }
  return current < monthStart.value || disabledRules(current)[disabledDateType]
}

const monthReset = () => {
  monthStart.value = null
  monthEnd.value = null
}

defineExpose({
  monthReset
})
</script>
<style lang="scss" scoped>
.MonthRangePicker {
  width: 342px;

  .spaceText {
    color: #d9d9d9;
    padding: 0 5px;
  }
}
::v-deep(.ant-calendar-picker) {
  width: 160px;
  input {
    text-indent: 20px;
  }
}
</style>
